import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, startWith } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from "moment";
import { Business, BusinessConsent } from 'backend/interfaces/business.interface';
import { BusinessService } from 'src/app/admin/services/business.service';
import { AuthService } from 'src/app/auth/auth.service';
import { GroupService } from 'src/app/admin/services/group.service';
import { BusinessStatus } from 'backend/enum/BusinessStatus.enum';
import { CategoriesComponent } from 'src/app/business/categories/categories.component';
import { Group } from 'backend/interfaces/group.interface';
import { BusinessDataService } from 'src/app/business/services/data.service';
import { SideNavService } from 'src/app/admin/services/side-nav.service';

import { cities } from 'backend/interfaces/business-areas';
export { cities } from 'backend/interfaces/business-areas';
@Component({
  selector: 'app-business-profile',
  templateUrl: './business-profile.component.html',
  styleUrls: ['./business-profile.component.scss']
})

export class BusinessProfileComponent implements OnInit {
  @Input() profile: Business;
  @Input() selectedCategory: Group;
  @Input() deferSave = false;
  currentUser;
  categories: Group[] = []
  saving = false;
  days: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  filteredCities: Observable<object[]>;
  @Output() emitProfile: EventEmitter<any> = new EventEmitter();

  webcamImageDisplaySrc: string | ArrayBuffer = './../../../assets/user.png';
  uploadedImage: { name: string, source: string | ArrayBuffer, type?: string };
  @ViewChild('fileInput') fileInput: ElementRef;
  @Output() emitMedical = new EventEmitter<Object>();
  statusArray = ['Active', 'Inactive'];
  constructor(private fb: UntypedFormBuilder, private businessService: BusinessService, private router: Router, private _snackBar: MatSnackBar, private authService: AuthService, private groupService: GroupService, private businessDataService: BusinessDataService, private sideNavService: SideNavService) {
    this.authService.$User.subscribe((res) => {
      if (res) {
        this.currentUser = res;
      }
    })
  }
  profileForm: UntypedFormGroup = this.fb.group({
    ProfilePicture: ['', Validators.required],
    Name: ['', Validators.required],
    AccountID: [''],
    RegistrationNumber: [''],
    Category: ['', Validators.required],
    OwnershipInfo: [''],
    Address: ['', Validators.required],
    Website: [''],
    Mobile: [''],
    Email: [''],
    Notes: [''],
    City: [''],
    InformedDataConsent: ['', Validators.required],
    OwnerID: ['', Validators.required],
    RegistrationDate: [''],
    Status: ['Pending'],
    About: ['', Validators.required],
    TradingHours: this.createTradingHoursControls()
  });
  medicalForm: UntypedFormGroup;
  thirdFormGroup = this.fb.group({
    thirdCtrl: ['', Validators.required]
  });
  async ngOnInit(): Promise<void> {
    this.filteredCities = this.profileForm.controls['City'].valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
    this.saving = true
    this.groupService.allGroups$.subscribe(async res => {
      if (res) {
        this.categories = res;
      }
    });
    this.businessDataService.business$.subscribe(async res => {
      if (res) {
        this.profile = res;
        this.profile.AccountID = res.id;
        const category = {
          name: this.profile.Category?.get('name'),
          description: this.profile.Category.get('description'),
          followers: this.profile.Category.get('followers'),
          id: this.profile.Category.id,
          logo: this.profile.Category.get('logo')
        }

        const hoursArray = await this.profile.TradingHours?.map((day) => {
          return this.fb.group({
            day: [day.day],
            open: [day.open],
            startTime: [day.startTime],
            endTime: [day.endTime],
          });
        });
        const existingPic = this.profile && this.profile.ProfilePicture && this.profile.ProfilePicture.source ? this.profile.ProfilePicture.source : '';
        if (existingPic) {
          this.webcamImageDisplaySrc = existingPic;
        }
        this.profileForm.patchValue({
          ProfilePicture: existingPic || '',
          Name: this.profile?.Name,
          AccountID: this.profile?.AccountID,
          RegistrationNumber: this.profile ? this.profile.RegistrationNumber : '',
          Category: this.profile ? category : null,
          OwnershipInfo: this.profile ? this.profile.OwnershipInfo : '',
          Address: this.profile ? this.profile.Address : '',
          Website: this.profile ? this.profile.Website : '',
          Mobile: this.profile ? this.profile.Mobile : '',
          Email: this.profile ? this.profile.Email : '',
          Notes: this.profile ? this.profile.Notes : '',
          InformedDataConsent: this.profile ? this.profile.InformedDataConsent : false,
          OwnerID: this.profile ? this.profile.OwnerID : '',
          RegistrationDate: this.profile ? this.profile.RegistrationDate : '',
          Status: this.profile ? this.profile.Status : 'Created',
          About: this.profile ? this.profile.About : '',
          TradingHours: this.profile ? this.profile.TradingHours : []
          // this.profile.TradingHours ? this.fb.array(this.profile.TradingHours?.map(r => this.fb.group(r))) : this.fb.array(this.createTradingHoursControls())
        });

      } else if (this.selectedCategory) {
        this.profileForm.patchValue({
          Category: {
            name: this.selectedCategory.name,
            description: this.selectedCategory.description,
            followers: this.selectedCategory.followers,
            id: this.selectedCategory.id,
            logo: this.selectedCategory.logo
          }
        });
      }
      console.log(this.profileForm.value)
      this.saving = false;
    });
  }
  async onFileSelected(event): Promise<void> {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file: File = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (file.type.includes('image')) {
          this.webcamImageDisplaySrc = reader.result;
          this.uploadedImage = {
            source: reader.result as string,
            name: file.name,
            type: file.type,
          }
          this.profileForm.controls['ProfilePicture'].setValue(reader.result);
          this.profileForm.controls['ProfilePicture'].markAsDirty();
        }
      };
    }
  }

  uploadFile() {
    this.fileInput.nativeElement.value = null;
    this.fileInput.nativeElement.click();
  }

  async saveProfile(forceSave = false) {
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      this.openSnackBar(
        this.profileForm.controls['ProfilePicture'].invalid
          ? 'Please add a business profile picture before continuing'
          : 'Please complete the required fields before continuing'
      );
      return;
    }

    if (this.deferSave && !forceSave) {
      this.emitProfile.emit({
        ...this.profileForm.value,
        ProfilePicture: this.uploadedImage || { source: this.profileForm.controls['ProfilePicture'].value }
      });
      return;
    }

    if (!this.profileForm.dirty && !this.uploadedImage && this.profile) {
      this.emitProfile.emit(this.profile);
      return;
    }

    const isUpdate = !!this.profile;
    this.saving = true;
    this.businessService
      .saveBusiness({ ...this.profileForm.value })
      .then(async (res) => {
        if (this.uploadedImage) {
          await this.businessService.saveProfilePicture(res.id, this.uploadedImage);
          res.ProfilePicture = this.uploadedImage;
        }
        return res;
      })
      .then((res) => {
        this.businessService.newBusinessEmail = undefined;
        this.openSnackBar(isUpdate
          ? 'Business profile updated successfully.'
          : 'Business saved. Review your listing before payment.');
        this.businessService.getBusinessCount();
        this.businessService.activatedBusiness.next(res);
        this.profile = res;
        this.profileForm.markAsPristine();
        this.saving = false;
        this.emitProfile.emit(res);
      })
      .catch((err) => {
        this.openSnackBar(err);
        this.saving = false;
      });
  }
  getErrorMessage() {
    if (this.profileForm.controls['Name'].hasError('required')) {
      return 'You must enter a value';
    }

    return this.profileForm.controls['Name'].hasError('required') ? 'Not a valid name' : '';
  }

  async saveBusinessConsent(event: { business: BusinessConsent, signature: string }) {
    this.saving = true;
    this.businessService
      .saveBusinessConsent(event.business)
      .then(res => {
        this.openSnackBar('Consent saved');
        this.emitProfile.emit(res);
        this.businessService.activatedBusiness.next(res);
        this.profileForm.reset();
        this.profileForm.markAsPristine();
        this.profileForm.clearValidators();
        this.saving = false;
      })
      .catch((err) => {
        this.openSnackBar(err);
        this.saving = false;
      });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }


  createTradingHoursControls() {
    return this.fb.array(this.days.map((day) =>
      this.fb.group({
        day: [day],
        open: [true],
        startTime: ['07:00'],
        endTime: ['17:00'],
      }))
    );
  }

  get tradingHoursControls(): FormArray {
    // console.log(this.profileForm.get('TradingHours') as FormArray)
    return this.profileForm.get('TradingHours') as FormArray;
  }

  // tell angular how to compare two objects
  compareFn(item1, item2): boolean {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  private _filter(value: string): object[] {
    const filterValue = value.toLowerCase();

    return cities.filter(option => option.city.toLowerCase().includes(filterValue));
  }
}

